var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"custom-alert",attrs:{"color":_vm.color,"icon":_vm.icon,"dense":"","outlined":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }